import moment from 'moment';

/** Formato que espera listProducts en shippingEtaInit*. */
export const formatListProductsDate = (value) => moment(value).format('YYYY-MM-DD HH:mm:ss');

/** Rango de fechas (inicio/fin de día) para el body de listProducts. */
export const buildListProductsDateFilters = (from, to) => ({
    shippingEtaInitStart: formatListProductsDate(moment(from).startOf('day')),
    shippingEtaInitEnd: formatListProductsDate(moment(to).endOf('day'))
});

/** Mapea payload de listProducts a la shape de la tabla agrupada. */
export const mapMarketplaceOrders = (rawOrders, storeId) => (rawOrders || []).map(order => ({
    orderId: order.orderId,
    itemCount: (order.products || []).length,
    deliveryDate: (order.shippingEta && order.shippingEta.init) || null,
    products: order.products || [],
    sala: order.sala || storeId || null
}));

/** Fecha de entrega en UI: { date: DD/MM/YYYY, time: HH:mm }. */
export const formatDeliveryDate = (iso) => {
    if (!iso) return { date: '-', time: '' };
    const d = new Date(iso);
    const pad = (n) => String(n).padStart(2, '0');
    return {
        date: `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`,
        time: `${pad(d.getHours())}:${pad(d.getMinutes())}`
    };
};

/** Filas de la tabla agrupada = suma de productos (rowspan por orden). */
export const countGroupedTableRows = (orders) =>
    (orders || []).reduce((acc, order) => acc + ((order.products && order.products.length) || 0), 0);
